<dx-toolbar [dataSource]="ds" class="map-layers-control-toolbar"></dx-toolbar>
